import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SapService } from 'src/app/api/sap.service';
import { variableGlobal } from 'src/app/global.enum';
import { Columns, Config, DefaultConfig, APIDefinition, API } from 'ngx-easy-table';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CrearOportunidadComponent } from './crear-oportunidad/crear-oportunidad.component';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import {
  CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import Swal from 'sweetalert2';
import { eventTarget } from '@amcharts/amcharts4/.internal/core/utils/DOM';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { environment } from 'src/environments/environment.prod';
import { CdkDragMove } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-oportunidad',
  templateUrl: './oportunidad.component.html',
  styleUrls: ['./oportunidad.component.css']
})
export class OportunidadComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private _api: IntranetoldService,
    private _sap: SapService,
    private _dbService: NgxIndexedDBService,

  ) { }

  public configuration: Config;
  public columns: Columns[];
  AllMaestroArticulos: any;
  querys: any;
  @ViewChild('frmAccion', { static: true }) frmAccion: TemplateRef<any>;
  data: any;
  articuloeliminar: any;
  administrador: any;
  Etapas: any;
  EtapasView: any;
  listaVendedor: any;
  cargando: boolean = false;
  DESDE: any;
  HASTA: any;
  NOMBREFILTROOPORTUNIDAD: any;
  NUMEROFILTROOPORTUNIDAD: any;
  OPORTUNIDADES_CATEGORIA: any;
  login: any;
  usuarios: any;
  usuarioON: any;
  dataView: any;
  perfilUsuario: any;

  @ViewChild('frmCreateDate', { static: true }) frmCreateDate: TemplateRef<any>;
  @ViewChild('frmPredDate', { static: true }) frmPredDate: TemplateRef<any>;
  @ViewChild('frmCloPrcnt', { static: true }) frmCloPrcnt: TemplateRef<any>;
  @ViewChild('frmSlpCode', { static: true }) frmSlpCode: TemplateRef<any>;
  @ViewChild('frmCategorias', { static: true }) frmCategorias: TemplateRef<any>;
  @ViewChild('frmStepLast', { static: true }) frmStepLast: TemplateRef<any>;
  @ViewChild('frmMaxSumLoc', { static: true }) frmMaxSumLoc: TemplateRef<any>;
  @ViewChild('frmOpprId', { static: true }) frmOpprId: TemplateRef<any>;
  @ViewChild('frmName', { static: true }) frmName: TemplateRef<any>;
  @ViewChild('frmCardName', { static: true }) frmCardName: TemplateRef<any>;

  async ngOnInit(): Promise<void> {
    await this.cargaInicial();
  }

  async testLeo() {

    let res: any = await this._sap.obtieneOportunidadModel("63ffd6056cb4c756ab9d5a6d");

    
    

    let dataSinDocNum = this.dataView.filter(x => !x.DocNum)

    dataSinDocNum.forEach(element => {
      element.MaxSumLoc = Math.floor(element.MaxSumLoc);
    });
    

    

    let cotizaciones: any = await this.obtieneQueryMongo('prueba');
    cotizaciones = await this._api.GetNotFileQuery(cotizaciones);
    cotizaciones = cotizaciones.objeto;
    

    let match: any[] = [];
    let duplicates: any[] = [];

    // Recorremos las oportunidades
    dataSinDocNum.forEach(opor => {
      let countMatches = 0;  // Contador para las coincidencias de una oportunidad específica
      let tempObj = null;

      // Recorremos las cotizaciones para cada oportunidad
      cotizaciones.forEach(cot => {
        if (opor.CardCode === cot.CardCode && opor.CreateDate == cot.DocDate ) {
          countMatches++;  // Incrementamos el contador si coincide



          // Guardamos el objeto si es la primera coincidencia
          if (!tempObj) {
            tempObj = {
              "CardCode": opor.CardCode,
              "CreateDate": opor.CreateDate,
              "MaxSumLoc": opor.MaxSumLoc,
              "CardName":cot.CardName,
              "OpprId":opor.OpprId,
              "cot":cot
            };
          }
        }
      });

      // Si encontramos una coincidencia, agregamos el objeto al arreglo 'match'
      if (countMatches > 0) {
        match.push(tempObj);
      }

      // Si hubo más de una coincidencia, agregamos también al arreglo 'duplicates'
      if (countMatches > 1) {
        duplicates.push(tempObj);
      }
    });

    match.sort((a, b) => {
      return new Date(a.CreateDate).getTime() - new Date(b.CreateDate).getTime();
    });

    

    let countMatchesUpdate = 0;
    
    match.forEach(async element => {
      countMatchesUpdate++;

      
      //res = await this._api.GetNotFileQuery('UPDATE "OOPR" SET "DocNum" = '+element.cot.DocNum+', "DocEntry" = '+element.cot.DocEntry+', "DocType" = '+element.cot.ObjType+' WHERE "OpprId" = '+"'"+element.OpprId+"'");
      
    });

    



  }

  async cargaInicial() {

    this.cargando = true;

    await this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_login).subscribe(
      async item => {
        var itemx: any = item;
        this.login = itemx.datos.login;

        


        var res: any = await this._api.getAllLogin();
        if (res.estado) {
          this.usuarios = [...res.objeto];
          this.usuarios = this.usuarios.filter(x => x._id == this.login._id);
          this.usuarioON = this.usuarios[0];


          this.perfilUsuario = JSON.parse(localStorage.getItem("PERFILJSON"));

          

          await this.cargaOportunidades();
          await this.cargaEtapas();
        }

        
        
        

        this.dataView.forEach(element => {
          element.PredDate = this.transformarFechaISOaInputDate(element.PredDate)
        });

        let EtapaNoSeConcreta = this.EtapasView.shift();
        
        this.EtapasView.push(EtapaNoSeConcreta);

        
        //this.testLeo();
        // El resto de tu código va aquí
      }
    )


    let listaVendedor: any = await this.obtieneQueryMongo('listaVendedor');
    listaVendedor = await this._api.GetNotFileQuery(listaVendedor);
    this.listaVendedor = listaVendedor.objeto;

    let OPORTUNIDADES_CATEGORIA: any = await this.obtieneQueryMongo('OPORTUNIDADES_CATEGORIA');
    OPORTUNIDADES_CATEGORIA = await this._api.GetNotFileQuery(OPORTUNIDADES_CATEGORIA);
    this.OPORTUNIDADES_CATEGORIA = OPORTUNIDADES_CATEGORIA.objeto;

    


    
    this.listaVendedor.sort((a, b) => a.SlpName.localeCompare(b.SlpName));

    this.columns = [
      { key: 'OpprId', title: 'N°', cellTemplate: this.frmOpprId },
      { key: 'Name', title: 'Oportunidad', cellTemplate: this.frmName },
      { key: 'CardName', title: 'Empresa', cellTemplate: this.frmCardName },
      //  { key: 'CardCode', title: 'Persona de Contacto' },
      { key: 'CreateDate', title: 'Fecha Creación', cellTemplate: this.frmCreateDate },
      { key: 'PredDate', title: 'Fecha Cierre', cellTemplate: this.frmPredDate },
      { key: 'MaxSumLoc', title: 'Monto', cellTemplate: this.frmMaxSumLoc },
      { key: 'StepLast', title: 'Estado', cellTemplate: this.frmStepLast },
      { key: 'SlpCode', title: 'Vendedor', cellTemplate: this.frmSlpCode },
      { key: '', title: 'Categorías', cellTemplate: this.frmCategorias },
      { key: '', title: 'Acción', cellTemplate: this.frmAccion },
      //{ key: 'CloPrcnt', title: 'Progreso', cellTemplate: this.frmCloPrcnt },

    ];

    this.configuration = {
      ...DefaultConfig,
      searchEnabled: true,
      detailsTemplate: true,
      paginationRangeEnabled: true,
      paginationEnabled: true,
      horizontalScroll: true,
      resizeColumn: false,
      orderEnabled: true,
      rowReorder: false,
      columnReorder: false,
      fixedColumnWidth: true,
    };

    

    


    this.cargando = false;

  }

  transformarFechaISOaInputDate(fechaISO: string): string {
    const fecha = new Date(fechaISO);
    const year = fecha.getFullYear();
    const month = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Mes en formato 2 dígitos
    const day = fecha.getDate().toString().padStart(2, '0'); // Día en formato 2 dígitos
    
    return `${year}-${month}-${day}`;
  }

  async cargaOportunidades() {

    let res: any = await this._sap.obtieneOportunidadModel("63ffd6056cb4c756ab9d5a6d");
    
    res = res.resultado;

    let oportunidades = []

    res.forEach(element => {
      element.oportunidades.forEach(x => {
        oportunidades.push(x);
      });
    });

    

    if (!this.perfilUsuario.NOMBRE.toLowerCase().includes("administrador")) {

      if (this.perfilUsuario.NOMBRE.toLowerCase().includes("pm")) {

        let oportunidadesFiltradas = [];

        

        oportunidades.forEach(opor => {
          if (this.usuarioON.CATEGORIAS.some(categoriaUsuario => opor.CATEGORIAS.some(categoriaOportunidad => categoriaOportunidad.ItmsGrpNam === categoriaUsuario.ItmsGrpNam))) {
            oportunidadesFiltradas.push(opor);
          }
        });

        oportunidades = [...oportunidadesFiltradas];
        


      }
      else {

        if (this.usuarioON.CATEGORIAS) {
          const tieneCategoriaCero = this.usuarioON.CATEGORIAS.some(categoriaUsuario => categoriaUsuario.ItmsGrpCod === "0");
          let oportunidadesFiltradas = [];
          oportunidades.forEach(opor => {
            if (tieneCategoriaCero) {

              if (opor.SlpCode === this.usuarioON.VENDEDOR) {
                oportunidadesFiltradas.push(opor);
              }
            } else {
              if (this.usuarioON.CATEGORIAS.some(categoriaUsuario => opor.CATEGORIAS.some(categoriaOportunidad => categoriaOportunidad.ItmsGrpNam === categoriaUsuario.ItmsGrpNam))) {
                oportunidadesFiltradas.push(opor);
              }
            }
          });

          oportunidades = oportunidadesFiltradas;
        }
        else {
          oportunidades = [];
        }

      }
    }



    oportunidades.sort((a, b) => b.OpprId - a.OpprId);

    this.data = oportunidades;

    this.dataView = this.data;


  }

  async cargaEtapas() {

    let res: any = await this._sap.obtieneOportunidadModel("63ffd6056cb4c756ab9d5a6d");

    this.Etapas = res.resultado;

    this.Etapas.forEach(element => {

      if (!this.perfilUsuario.NOMBRE.toLowerCase().includes("administrador")) {

        if (this.perfilUsuario.NOMBRE.toLowerCase().includes("pm")) {

          let oportunidadesFiltradas = [];

          element.oportunidades.forEach(opor => {
            if (this.usuarioON.CATEGORIAS.some(categoriaUsuario => opor.CATEGORIAS.some(categoriaOportunidad => categoriaOportunidad.ItmsGrpNam === categoriaUsuario.ItmsGrpNam))) {
              oportunidadesFiltradas.push(opor);
            }
          });

          element.oportunidades = [...oportunidadesFiltradas];
        }
        else {

          if (this.usuarioON.CATEGORIAS) {
            const tieneCategoriaCero = this.usuarioON.CATEGORIAS.some(categoriaUsuario => categoriaUsuario.ItmsGrpCod === "0");
            let oportunidadesFiltradas = [];
            element.oportunidades.forEach(opor => {
              if (tieneCategoriaCero) {

                if (opor.SlpCode === this.usuarioON.VENDEDOR) {
                  oportunidadesFiltradas.push(opor);
                }
              } else {
                if (this.usuarioON.CATEGORIAS.some(categoriaUsuario => opor.CATEGORIAS.some(categoriaOportunidad => categoriaOportunidad.ItmsGrpNam === categoriaUsuario.ItmsGrpNam))) {
                  oportunidadesFiltradas.push(opor);
                }
              }
            });

            element.oportunidades = oportunidadesFiltradas;
          }
          else {
            element.oportunidades = [];
          }

        }
      }


      element.totalOportunidades = 0;

      element.oportunidades.forEach(item => {
        element.totalOportunidades = element.totalOportunidades + item.MaxSumLoc;
      });

    });

    this.Etapas.forEach(element => {
      element.oportunidades.sort((a, b) => new Date(b.CreateDate).getTime() - new Date(a.CreateDate).getTime());
    });

    this.EtapasView = this.Etapas;

  }

  crearOportunidad() {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "xl",
      animation: true,
      modalDialogClass: variableGlobal.CLASS_MODAL_BG,
    };

    const modalRef = this.modalService.open(CrearOportunidadComponent, ngbModalOptions);
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.componentInstance.crear = true;

    modalRef.result.then(async (data) => {
      await this.cargaOportunidades();
      await this.cargaEtapas();
      await this.cargaInicial();
    });
  }

  async obtieneQueryMongo(nombre) {
    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
      if (element.NOMBRE == nombre) {
        query = element.CONSULTA;
      }
    });
    return query;
  }

  drop(event: CdkDragDrop<string[]>, item: any) {

    if (event.previousContainer.id != event.container.id) {

      Swal.fire({
        title: item.Descript,
        input: 'text',
        inputPlaceholder: 'Comentario',
        showCancelButton: true,
        confirmButtonText: 'Actualizar Etapa',
        cancelButtonText: 'Cancelar',
        preConfirm: (memo) => {
          return memo;
        }
      }).then(async (result) => {
        if (result.isConfirmed) {

          const memo = result.value;

          if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
          } else {

            transferArrayItem(
              event.previousContainer.data,
              event.container.data,
              event.previousIndex,
              event.currentIndex,
            );

            this.cargando = true;

            
            

            
            

            const draggedObject: any = event.container.data[event.currentIndex];
            

            let res: any = await this._sap.obtieneOportunidad(draggedObject.OpprId);
            res = res.resultado;
            let oportunidad: any = { ...res.OPR1[res.OPR1.length - 1] };
            
            

            oportunidad.Memo = memo;
            oportunidad.Step_Id = item.StepId;
            oportunidad.Line = -1;
            oportunidad.CloPrcnt = item.CloPrcnt;
            oportunidad.OpenDate = res.OPR1[res.OPR1.length - 1].OpenDate;
            oportunidad.CloseDate = res.OPR1[res.OPR1.length - 1].CloseDate;

            

            res.OPR1.push(oportunidad);

            

            res = await this._sap.creaActualizaOportunidad(res);
            

            //await this.cargaOportunidades();
            //await this.cargaEtapas();
            //await this.cargaInicial();

            Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            }).fire({
              icon: 'success',
              title: res.mensaje
            });

            this.cargando = false;

          }
        } else {
          // Lógica para manejar el caso en que el usuario cancela la acción
          // ...
        }
      });

    }

  }

  obtenerFechaActualEnFormato(): string {
    const fecha = new Date();
    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Mes comienza desde 0
    const dia = fecha.getDate().toString().padStart(2, '0');
    const horas = '00';
    const minutos = '00';
    const segundos = '00';

    const fechaFormateada = `${año}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
    return fechaFormateada;
  }

  abrirOportunidad(event: any, OpprId: any): void {

    if (event) {

      if (event.event == "onDoubleClick") {

        var data: any = event.value.row;

        if (event) {
          window.location.href = '/Oportunidad/Detalle/' + data.OpprId;
        }

      }

    }

    if (OpprId) {
      window.location.href = '/Oportunidad/Detalle/' + OpprId;
    }

  }

  SLPCODEFILTRO: any;
  CATEGORIAFILTROOPORTUNIDAD: any;

  filtrarOportunidades() {

    var copyEtapas = [...JSON.parse(JSON.stringify(this.Etapas))];

    
    
    
    copyEtapas = copyEtapas.map(element => {
      if (this.DESDE) {
        element.oportunidades = element.oportunidades.filter(
          item =>
            new Date(item.PredDate) >= new Date(this.DESDE) &&
            (!this.HASTA || new Date(item.PredDate) <= new Date(this.HASTA))
        );
      }

      
      

      if (this.HASTA && !this.DESDE) {
        const hastaDate = new Date(this.HASTA);
        const month = hastaDate.getMonth();
        const year = hastaDate.getFullYear();
        element.oportunidades = element.oportunidades.filter(item => {
          const itemDate = new Date(item.PredDate);
          return itemDate.getMonth() === month && itemDate.getFullYear() === year;
        });
      }

      if (this.SLPCODEFILTRO) {
        
        element.oportunidades = element.oportunidades.filter(
          item => item.SlpCode == this.SLPCODEFILTRO
        );
      }

      if (this.NUMEROFILTROOPORTUNIDAD) {

        element.oportunidades = element.oportunidades.filter(
          item => item.OpprId == this.NUMEROFILTROOPORTUNIDAD
        );
      }

      if (this.CATEGORIAFILTROOPORTUNIDAD) {
        element.oportunidades = element.oportunidades.filter(item => {
          return (
            item.CATEGORIAS &&
            item.CATEGORIAS.some(categoria =>
              categoria.ItmsGrpNam.toLowerCase().includes(this.CATEGORIAFILTROOPORTUNIDAD.toLowerCase())
            )
          );
        });
      }

      return element;
    });

    

    var copyData = this.data;

    if (this.DESDE) {
      copyData = copyData.filter(
        item =>
          new Date(item.PredDate) >= new Date(this.DESDE) &&
          (!this.HASTA || new Date(item.PredDate) <= new Date(this.HASTA))
      );
    }

    if (this.HASTA && !this.DESDE) {
      const hastaDate = new Date(this.HASTA);
      const month = hastaDate.getMonth();
      const year = hastaDate.getFullYear();
      copyData = copyData.filter(item => {
        const itemDate = new Date(item.PredDate);
        return itemDate.getMonth() === month && itemDate.getFullYear() === year;
      });
    }

    if (this.SLPCODEFILTRO) {
      copyData = copyData.filter(
        item => item.SlpCode == this.SLPCODEFILTRO
      );
    }

    if (this.NUMEROFILTROOPORTUNIDAD) {

      copyData = copyData.filter(
        item => item.OpprId == this.NUMEROFILTROOPORTUNIDAD
      );
    }

    if (this.CATEGORIAFILTROOPORTUNIDAD) {
      copyData = copyData.filter(item => {
        return (
          item.CATEGORIAS &&
          item.CATEGORIAS.some(categoria =>
            categoria.ItmsGrpNam &&
            categoria.ItmsGrpNam.toLowerCase().includes(this.CATEGORIAFILTROOPORTUNIDAD.toLowerCase())
          )
        );
      });
    }

    copyEtapas.forEach(element => {

      element.totalOportunidades = 0;

      element.oportunidades.forEach(item => {
        element.totalOportunidades = element.totalOportunidades + item.MaxSumLoc;
      });

    });

    



    this.EtapasView = [...copyEtapas];

    this.dataView = [...copyData];
    
  }



  async exportarExcel() {

    this.cargando = true;

    

    if (this.perfilUsuario.NOMBRE.toLowerCase().includes('pm')) {
      this.login._id = "63ffd6056cb4c756ab9d5a6d"
    }

    let res: any = await this._sap.obtieneOportunidadExcel(this.login._id);
    
    let url = environment.RUTA_API + res.resultado.rutaServer;
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'Invernada_Excel');
    link.style.display = 'none';
    document.body.appendChild(link);
    
    link.click();
    document.body.removeChild(link);

    this.cargando = false;

  }

  async actualizaOportunidad(opor: any) {
    this.cargando = true;
    let res: any = await this._sap.obtieneOportunidad(opor.OpprId);
    var oportunidadObtenida;
    if (res.estado) {
      oportunidadObtenida = res.resultado;
      oportunidadObtenida.PredDate = opor.PredDate
      
      oportunidadObtenida.OPR1[oportunidadObtenida.OPR1.length - 1].Step_Id = Number(opor.StepLast);
      
      res = await this._sap.creaActualizaOportunidad(oportunidadObtenida);
      if (res.estado) {
        Swal.fire({
          icon: 'success',
          title: res.mensaje,
          showConfirmButton: false,
          timer: 1500
        });
      }
    }
    this.cargando = false;
  }

  irADocLink(DocEntry:any,DocType:any){
    if (DocType == 23) {
      window.open('/Venta/23/'+DocEntry+'')
    }
    if (DocType == 17) {
      window.open('/Venta/17/'+DocEntry+'')
    }
  }

}
